import React from "react"

import { webSuppliers } from "@signals"
import { AppWebSuppliersAutocomplete } from "@components/Autocomplete"
import { chainFinish } from '@components/NewCommonFilters/@services/chainFinish'


export default function AppCommonFiltersWebSuppliersAutocomplete({ onOptions, onFinishAjax, ...props }) {
	return <AppWebSuppliersAutocomplete
		value={webSuppliers.value}
		onChange={e => webSuppliers.value = e.target.value}
		onFinishAjax={chainFinish(onFinishAjax, onOptions)}
		{...props}
	/>
}